export default __webpack_public_path__ + "static/media/Ticket.77143124.png";